const info = {
  name: "Sanjay RD",
  whatIDo:
    "I am a Frontend Developer,I enjoy making creative sites and learning new programming.",
  aboutme:
    "I enjoy building new projects ideas just to tickle my brain and love learning new programming language.",
  topExpertise: {
    title: "Fullstack developer with primary focus on Node/Express + React:",
    programmingLanguage: [
      "ReactJs",
      "Node & Express",
      "JavaScript",
      "Python Django",
      "Bootstrap",
      "Material-UI",
      "HTML / CSS",
    ],
  },
  findme: {
    image: "/images/gitprofile.png",
    facebook: "https://www.facebook.com/profile.php?id=100009024954986",
    linkedin: "https://www.linkedin.com/in/sanjay-rd-68881b1b4/",
    github: "https://github.com/Sanjay-RD",
  },
};

export default info;
